const MINUTE_S = 60
const HOUR_S = 60 * MINUTE_S
const DAY_S = 24 * HOUR_S

/**
 * Coarse "how long ago" label for a BOC row. Deliberately bucketed (now /
 * minutes / hours / days) so the panel stays readable and the poll interval
 * never has to be second-accurate. Clock skew between server-issued
 * `createdAt` and the browser clock can make the delta negative; such rows
 * read as "now" rather than jumping into the future.
 */
export function relativeOperationTime(
  createdAt: Date,
  now: Date,
  t: (
    key: string,
    named?: Record<string, unknown>,
    plural?: number,
  ) => string,
): string {
  const elapsedS = Math.floor(
    Math.max(now.getTime() - createdAt.getTime(), 0) / 1000,
  )

  if (elapsedS < MINUTE_S) {
    return t('operations.boc.time.now')
  }

  if (elapsedS < HOUR_S) {
    const minutes = Math.floor(elapsedS / MINUTE_S)
    return t('operations.boc.time.minutes', { count: minutes }, minutes)
  }

  if (elapsedS < DAY_S) {
    const hours = Math.floor(elapsedS / HOUR_S)
    return t('operations.boc.time.hours', { count: hours }, hours)
  }

  const days = Math.floor(elapsedS / DAY_S)
  return t('operations.boc.time.days', { count: days }, days)
}
